import { FilterCancelButtonClickEventArgs as FilterCancelButtonClickEventArgs_internal } from "./FilterCancelButtonClickEventArgs";
var IgrFilterCancelButtonClickEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrFilterCancelButtonClickEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrFilterCancelButtonClickEventArgs.prototype.createImplementation = function () {
        return new FilterCancelButtonClickEventArgs_internal();
    };
    Object.defineProperty(IgrFilterCancelButtonClickEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrFilterCancelButtonClickEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrFilterCancelButtonClickEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    return IgrFilterCancelButtonClickEventArgs;
}());
export { IgrFilterCancelButtonClickEventArgs };
//# sourceMappingURL=igr-filter-cancel-button-click-event-args.js.map
